import { lazy } from 'react';
import Tool from '../../shared/components/Tool';
import {
	MUTATION_DELETE_D_CASE,
	MUTATION_UPDATE_D_CASE,
} from '../../shared/gql/mutations';
import {
	QUERY_GET_ALL_D_CASES,
	QUERY_GET_D_CASE,
} from '../../shared/gql/queries';
import CaseProvider from '../../shared/providers/CaseProvider';

const DepositCase = lazy(() => import('./DepositCase'));
const Deposit = () => (
	<CaseProvider caseMutation={MUTATION_UPDATE_D_CASE}>
		<Tool
			caseQuery={QUERY_GET_D_CASE}
			allCasesQuery={QUERY_GET_ALL_D_CASES}
			deleteMutation={MUTATION_DELETE_D_CASE}
			partitionKey='F'
		>
			<DepositCase />
		</Tool>
	</CaseProvider>
);

export default Deposit;
